import httpApiApplication from 'app/http/httpApiApplication';
import { type TaxReturnPayment } from 'app/modules/Taxpayer/Payments/TaxReturnPayment/types';

export const BaseUrlTaxReturnPayment = '/taxreturnpayments';

export const saveNewPayment = async (
  request: TaxReturnPayment
): Promise<{ taxReturnPaymentId: string }> => {
  return httpApiApplication.post(BaseUrlTaxReturnPayment, request);
};
